import { useState, useEffect } from 'react';
import api from '@/lib/api';

/**
 * Single source of truth pro seznam laboratoří — `GET /api/laboratories`
 * (backend `app/domain/laboratories.py`). Nahrazuje hardcoded LABS konstanty
 * roztroušené po stránkách; přidání laboratoře je pak 1 řádek na backendu.
 *
 * Vrací `[{ code, name, certPrefix, dccUnit, color, isBuiltin }]`. Modul-level
 * cache — načte se jen jednou; admin CRUD ji invaliduje přes
 * `invalidateLaboratories()`, aby ostatní stránky viděly změnu při příštím mountu.
 */
let _cache = null;
let _inflight = null;

function _load() {
  if (_cache) return Promise.resolve(_cache);
  if (!_inflight) {
    _inflight = api
      .get('/laboratories')
      .then((r) => {
        _cache = Array.isArray(r.data) ? r.data : [];
        return _cache;
      })
      .catch(() => {
        _inflight = null; // umožní retry při příštím mountu
        return [];
      });
  }
  return _inflight;
}

export default function useLaboratories() {
  const [labs, setLabs] = useState(_cache || []);
  useEffect(() => {
    let active = true;
    _load().then((data) => {
      if (active) setLabs(data);
    });
    return () => {
      active = false;
    };
  }, []);
  return labs;
}

/**
 * Invaliduje modul-level cache — po admin CRUD mutaci laboratoří,
 * aby ostatní stránky (EtalonPage, LabSettingsPage…) při příštím mountu
 * načetly čerstvý seznam. Admin stránka „Laboratoře" si vede vlastní list state.
 */
export function invalidateLaboratories() {
  _cache = null;
  _inflight = null;
}
